module.exports = "<public-header></public-header>\r\n<div class=\"app-container\">\r\n  <main>\r\n<gerenciar-indicacao></gerenciar-indicacao>\r\n  </main>\r\n</div>\r\n<public-footer></public-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/_public-layout/pages/indicacao/indicacao.component.html
// module id = ./src/app/components/_public-layout/pages/indicacao/indicacao.component.html
// module chunks = main